// 飞行记录
export default {
    flyrecirdusermanage: 'летать рекорд',
    Flighttime: 'Время полета',
    starttime: 'Дата начала',
    to: 'до',
    endtime: 'Дата окончания',
    taketime: 'время отправления',
    landtime: 'Время посадки',
    Durflytime: 'Время полета',
    total: 'общее',
    records: 'записи',
    totaltime: 'Общее время',
    errmes: 'Сообщение об ошибке',
    surefly: 'Все нормально и может взлететь',
    dspeed: 'Двойная скорость',
    flymode: 'Режим полета',
    nextroute: 'Следующая путевая точка',
    nowposition: 'текущая позиция',
    pitch: 'Подача',
    rool: 'Рулон',
    high: 'высота',
    speed: 'скорость',
    play: 'Играть',
    total2: 'Все',
    collection: 'Избранное',
    remarks: 'Замечания',
    VP: 'Напряжение/Mощность',
    flyingHeight: 'Высота полета',
    positioningStatus: 'Статус позиционирования',
    NS: 'Количество спутников',
    rtk: 'RTK',
    voltage: 'Напряжение',
    power: 'Mощность',
    time: 'время',
}